import { Industry } from 'APIs/industries/industries.types';
import { MerchantMarketplaceSettingsResponse } from 'APIs/marketplaces/merchant.marketplaces.settings.types';
import React from 'react';

import { DataLabel, MerchantSettingsView, MultiColRow, SubTitle } from './styles';

type Props = {
  merchantSettings: MerchantMarketplaceSettingsResponse | null;
  industries: Array<Industry>;
};

const MerchantMarketplaceSettingsView = ({ merchantSettings, industries }: Props) => {
  return (
    <>
      {merchantSettings && (
        <MerchantSettingsView>
          <MultiColRow>
            <div className="col">
              <DataLabel className="label">Business Name</DataLabel>
              <DataLabel className="value">{merchantSettings.businessRegistration.businessName}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Business Type</DataLabel>
              <DataLabel className="value">{merchantSettings.businessRegistration.businessType}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Industry</DataLabel>
              <DataLabel className="value">{merchantSettings.businessRegistration.industry}</DataLabel>
            </div>
          </MultiColRow>

          <MultiColRow>
            <div className="col">
              <DataLabel className="label">Tax ID</DataLabel>
              <DataLabel className="value">{merchantSettings.businessRegistration.taxId}</DataLabel>
            </div>
            <div className="col"></div>
            <div className="col"></div>
          </MultiColRow>

          <SubTitle>Branding</SubTitle>

          <MultiColRow>
            <div className="col">
              <DataLabel className="label">Display Name</DataLabel>
              <DataLabel className="value">{merchantSettings.branding?.businessDisplayName ?? '-'}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Website</DataLabel>
              <DataLabel className="value">{merchantSettings.branding?.businessWebsite ?? '-'}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Support Email</DataLabel>
              <DataLabel className="value">{merchantSettings.branding?.supportEmail ?? '-'}</DataLabel>
            </div>
          </MultiColRow>

          <MultiColRow>
            <div className="col">
              <DataLabel className="label">Icon URI</DataLabel>
              <DataLabel className="value">{merchantSettings.branding?.iconUri ?? '-'}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Logo URI</DataLabel>
              <DataLabel className="value">{merchantSettings.branding?.logoUri ?? '-'}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Logo ALT Text</DataLabel>
              <DataLabel className="value">{merchantSettings.branding?.logoAltText ?? '-'}</DataLabel>
            </div>
          </MultiColRow>

          <SubTitle>Contact details</SubTitle>

          <MultiColRow>
            <div className="col">
              <DataLabel className="label">First Name</DataLabel>
              <DataLabel className="value">{merchantSettings.businessContact.contactPerson.firstName}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Last Name</DataLabel>
              <DataLabel className="value">{merchantSettings.businessContact.contactPerson.lastName}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Title</DataLabel>
              <DataLabel className="value">{merchantSettings.businessContact.contactPerson.title}</DataLabel>
            </div>
          </MultiColRow>

          <MultiColRow>
            <div className="col">
              <DataLabel className="label">Contact email</DataLabel>
              <DataLabel>{merchantSettings.businessContact.contactEmail}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Phone Number</DataLabel>
              <DataLabel className="value">{merchantSettings.businessContact.phoneNo}</DataLabel>
            </div>
            <div className="col"> </div>
          </MultiColRow>

          <SubTitle>Business address</SubTitle>

          <MultiColRow>
            <div className="col">
              <DataLabel className="label">Unit Number</DataLabel>
              <DataLabel className="value">{merchantSettings.businessContact.address.unitNumber ?? '-'}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Street Number</DataLabel>
              <DataLabel className="value">{merchantSettings.businessContact.address.streetNumber}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Street Name</DataLabel>
              <DataLabel className="value">{merchantSettings.businessContact.address.streetName}</DataLabel>
            </div>
          </MultiColRow>

          <MultiColRow>
            <div className="col">
              <DataLabel className="label">Street Type</DataLabel>
              <DataLabel className="value">{merchantSettings.businessContact.address.streetType}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Suburb</DataLabel>
              <DataLabel className="value">{merchantSettings.businessContact.address.suburb}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Postal Code</DataLabel>
              <DataLabel className="value">{merchantSettings.businessContact.address.postalCode}</DataLabel>
            </div>
          </MultiColRow>

          <MultiColRow>
            <div className="col">
              <DataLabel className="label">State</DataLabel>
              <DataLabel className="value">{merchantSettings.businessContact.address.state ?? '-'}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">City</DataLabel>
              <DataLabel className="value">{merchantSettings.businessContact.address.city ?? '-'}</DataLabel>
            </div>
            <div className="col">
              <DataLabel className="label">Country</DataLabel>
              <DataLabel className="value">{merchantSettings.businessContact.address.country}</DataLabel>
            </div>
          </MultiColRow>
        </MerchantSettingsView>
      )}
    </>
  );
};

export default MerchantMarketplaceSettingsView;
